<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">网格信息维护&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>网格长留言管理</div>
        </div>
      </div>
    </div>
    <div class="section" v-if="!dialogVisible">
      <div style="padding: 28px 24px 0px 24px;">
        <div class="title">网格留言管理列表</div>
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%;width: 100%;">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="点位名称">
                  <el-input
                    v-model="form.pointName"
                    clearable
                    placeholder="请输入点位名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="建议时间">
                  <el-date-picker
                    v-model="form.times"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="答复状态">
                  <el-select
                    filterable
                    placeholder="请选择答复状态"
                    clearable
                    v-model="form.status"
                  >
                    <el-option
                      v-for="item in openFlagOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button
                    @click="getPointLeaveMessageListPageFun"
                    class="search"
                    >查询</el-button
                  >
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="aside">
        <div
          class="message-box-item"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <div class="left">
            <div class="top">
              <img class="index-box" src="@/assets/image/liuyan.png" alt="" />
              <div class="top-title">{{ item.leaveTitle }}</div>
              <div class="status" v-if="item.status == 1">
                待回复
              </div>
              <div class="status status1" v-if="item.status == 2">
                待审核
              </div>
              <div class="status status2" v-if="item.status == 3">
                已完成（已发布）
              </div>
            </div>
            <div class="center">{{ item.leaveContent }}</div>
            <div class="bottom">
              <div class="bottom-item">
                <img src="@/assets/image/sj.png" alt="" />
                <div style="margin: 0 8px;color: #92979c;">建议时间</div>
                <div>{{ item.createTime }}</div>
              </div>
              <div class="bottom-item">
                <img src="@/assets/image/wz.png" alt="" />
                <div style="margin: 0 8px;color: #92979c;">点位</div>
                <div>
                  {{ item.pointName }}
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <el-button
              @click="openDialogFun(item, true)"
              icon="el-icon-tickets"
              style="width: 80px; font-size: 16px;color: #0090FF;margin-right: 0;"
              type="text"
              >详情</el-button
            >
            <el-button
              v-if="item.status == 2"
              @click="openDialogFun(item, false)"
              icon="el-icon-s-check"
              style="width: 80px; font-size: 16px;color: #0090FF;margin-right: 0;"
              type="text"
              >审核</el-button
            >
            <el-button
              v-if="item.status == 1"
              @click="openDialogFun(item, false)"
              icon="el-icon-message"
              style="width: 80px; font-size: 16px;color: #0090FF;margin-right: 0;"
              type="text"
              >答复</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <detail
      class="section"
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
      :isDetail="isDetail"
      @refreshList="getPointLeaveMessageListPageFun"
    >
    </detail>
  </div>
</template>
<script>
import { getPointLeaveMessageListPage } from "@/api/block.js";
import detail from "./components/detail.vue";
import moment from "moment";
export default {
  components: {
    detail
  },
  data() {
    return {
      form: {
        pointName: "",
        times: [],
        status: ""
      },
      openFlagOptions: [
        {
          label: "暂存",
          value: 0
        },
        {
          label: "待回复",
          value: 1
        },
        {
          label: "待审核",
          value: 2
        },
        {
          label: "已完成（已发布）",
          value: 3
        },
        {
          label: "审核不通过",
          value: 4
        }
      ],
      dialogVisible: false,
      curItem: {},
      messageList: [],
      isDetail: false
    };
  },
  mounted() {
    this.getPointLeaveMessageListPageFun();
  },
  methods: {
    openDialogFun(item, isDetail) {
      this.dialogVisible = true;
      this.curItem = item;
      this.isDetail = isDetail;
    },
    onReset() {
      this.form.pointName = "";
      this.form.status = "";
      this.form.times = [];
      this.getPointLeaveMessageListPageFun();
    },
    // 分页查询
    async getPointLeaveMessageListPageFun() {
      let params = {
        pointName: this.form.pointName,
        status: this.form.status,
        createTimeStart:
          this.form.times && this.form.times.length
            ? moment(this.form.times[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        createTimeEnd:
          this.form.times && this.form.times.length
            ? moment(this.form.times[1]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        page: 1,
        size: 9999
      };
      const res = await getPointLeaveMessageListPage(params);
      if (res.data.code == 200) {
        this.messageList = res.data.data.records;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.box-father {
  padding-bottom: 24px;
}
.aside {
  height: calc(100% - 140px);
  overflow: auto;
}
.title {
  font-family: MiSans, MiSans;
  font-weight: 700;
  font-size: 20px;
  color: #494c4f;
  margin-bottom: 20px;
}
.box-father .section {
  padding: 0;
}
.message-box-item {
  padding: 24px 32px;
  border-top: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  .left {
    height: 100%;
    width: calc(100% - 192px);
    .top {
      display: flex;
      align-items: center;
      .index-box {
        height: 24px;
        margin-right: 10px;
      }
      .top-title {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
        margin-right: 12px;
      }
      .status {
        background: rgba(138, 144, 154, 0.09);
        border-radius: 2px;
        padding: 2px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;
        color: #92979c;
      }
      .status1 {
        background: rgba(255, 139, 70, 0.1);
        color: #ff8b46;
      }
      .status2 {
        background: rgba(12, 206, 179, 0.1);
        color: #00ac94;
      }
    }
    .center {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-top: 8px;
    }
    .bottom {
      display: flex;
      align-items: center;
      margin-top: 8px;
      .bottom-item {
        display: flex;
        align-items: center;
        margin-right: 56px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;

        color: #494c4f;
        img {
          height: 15px;
        }
      }
    }
  }
  .right {
    height: 100%;
    width: 192px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/streetInfo/message/index.vue